import React from 'react';
import { Helmet } from 'react-helmet';

interface Props {
	title: string;
	description: string;
	ogTitle?: string;
	ogDescription?: string;
	ogImage?: string;
	ogUrl?: string;
}

const Seo = ({ title, description, ogTitle, ogDescription, ogImage, ogUrl }: Props) => {
	return (
		<Helmet>
			<title>{title}</title>
			<meta name="description" content={description} />
			<meta property="og:title" content={ogTitle} />
			<meta property="og:description" content={ogDescription} />
			<meta
				property="og:image"
				content={ogImage ?? 'https://masai-website-images.s3.ap-south-1.amazonaws.com/JS_OG_Lanidng_Page_7843e7add9.png'}
			/>
			<meta property="og:url" content={ogUrl} />
			<meta property="og:type" content="website" />
		</Helmet>
	);
};

export default Seo;
